"use client";
import React from "react";
import { usePathname } from "next/navigation";
import classNames from "classnames";
import styles from "./header.module.css";

const BackBtn = () => {
  const pathname = usePathname();
  const isHomePage = pathname === "/";
  if (isHomePage) {
    return null;
  }
  return (
    <div
      className={classNames(
        styles.header,
        "container text-sm  pt-4 cursor-pointer flex items-center gap-1 !bg-[#f3f2ef]"
      )}
      onClick={() => {
        window.history.back();
      }}
    >
      <span aria-hidden="true">←</span>
      <span className="underline">Back</span>
    </div>
  );
};

export default BackBtn;
